import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LandingModule as StaticLandingModule } from '@static-client/src/app/landing/landing.module';

import { LandingComponent } from '@static-client/src/app/landing/landing.component';

import { NonRootGuard } from '@main-client/src/app/core/non-root.guard';
import { LandingGuard } from '@main-client/src/app/landing/landing.guard';

@NgModule({
  imports: [
    StaticLandingModule,
    RouterModule.forChild([
      {
        path: '',
        component: LandingComponent,
        canActivate: [NonRootGuard, LandingGuard],
      },
    ]),
  ],
  providers: [LandingGuard],
})
export class LandingModule {}
